import React from "react";
import Flight from './Flight';
import Next from './Next';
import Input from './Form/Input';


export default class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      summaryData: {
        agreement: false
      }
    };
  }

  componentDidMount() {
    setTimeout(() => {
      let top = document.getElementById("summary").getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top - 60,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }

  cb = (params) => {
    const n = { [params.field]: params.value };
    this.setState({summaryData : {...this.state.summaryData, ...n}});
    this.props.callback(params);
  }


  render() {
    const ll = this.props.flightData.flight;
    return (
      <>
        <div className="name">
          <div className="label">Name</div>
          <div className="val">{this.props.userData.name} {this.props.userData.lastName}</div>
          <div className="company">{this.props.userData.company} ({this.props.userData.employees})</div>
        </div>
        <div className="hr"></div>
        <div className="row">
          <div className="col-md-6 email">
            <div className="label">Email</div>
            <div className="val">{this.props.userData.email}</div>
          </div>
          <div className="col-md-6 phone">
            <div className="label">Phone</div>
            <div className="val">{this.props.userData.phone}</div>
          </div>
        </div>
        <div className="hr"></div>
        <div className={"launch active"}>
          <Flight {...ll} />
        </div>
        <div className="hr"></div>
        <div class="addons">
          <div className="label mb-3">Additional services</div>
          <div class="active-services row">
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Integration at launch site') ? 'active ' : '') +"b-Integration b-icon d-flex flex-row align-items-center"}>
                Integration at launch site
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Insurance') ? 'active ' : '') +"b-Insurance b-icon d-flex flex-row align-items-center"}>
                Insurance
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Mission analysis and design') ? 'active ' : '') +"b-Mission analysis b-icon d-flex flex-row align-items-center"}>
                Mission analysis and design
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Licensing') ? 'active ' : '') +"b-Licensing b-icon d-flex flex-row align-items-center"}>
                Licensing
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Shipping terrestrial transportation') ? 'active ' : '') +"b-Shipping b-icon d-flex flex-row align-items-center"}>
                Shipping terrestrial transportation
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Mission control operations') ? 'active ' : '') +"b-Mission control b-icon d-flex flex-row align-items-center"}>
                Mission control operations
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Cloud computing') ? 'active ' : '') +"b-Cloud b-icon d-flex flex-row align-items-center"}>
                Cloud computing
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Radio frequency registration') ? 'active ' : '') +"b-Radio b-icon d-flex flex-row align-items-center"}>
                Radio frequency registration
              </div>
            </div>
            <div className="col-6">
              <div class={(this.props.addOnsData.addOns.includes('Qualification test activities') ? 'active ' : '') +"b-Qualification b-icon d-flex flex-row align-items-center"}>
                Qualification test activities
              </div>
            </div>
          </div>
        </div>

        <div className="hr"></div>

        <Input
          type="switch"
          name="agreement"
          label="Agreement"
          callback={this.cb}
          help={<>Turn this switch on to accept the <a href="https://www.dorbit.space/terms-of-use" target="_blank">Terms and Conditions</a> of this service and our <a href="https://www.dorbit.space/downloads/privacy-policy.pdf" target="_blank">Privacy policy</a>.</>}
        />

        {(this.state.summaryData.agreement) ?
          (
            <Next
              callback={this.props.end}
              text="Confirm and submit"
              btnClass="btn btn-success w-100 text-center"
            />
          )
          :
          (
            <Next
              text="Confirm and submit"
              btnClass="btn btn-success w-100 text-center"
              disabled
            />
          )
        }
      </>
    );
  }
}
